// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3kP-3","buttons":"Footer_buttons__1Uf3l"};